import { isCalculationTermComplete } from '@bindoc-projects/util-domain-lib';
import type { OverrideProperty } from '@bindoc-projects/util-domain-lib';
import type { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { VirtualClinicAnalysisOperatingNumberTerm } from './term';
import type { VirtualClinicAnalysisFullyInpatientCasesFilter } from '../filter/fully-inpatient-cases';
import type { VirtualClinicAnalysisOperatingNumberConstantTermSpec } from '../../resolving';

export class VirtualClinicAnalysisOperatingNumberConstant extends VirtualClinicAnalysisOperatingNumberTerm {
  public static fromObject(
    obj: { value?: number } = {},
  ): VirtualClinicAnalysisOperatingNumberConstant {
    return new VirtualClinicAnalysisOperatingNumberConstant(obj.value);
  }

  constructor(public value: number) {
    super('constant');
  }

  clone(): VirtualClinicAnalysisOperatingNumberTerm {
    return new VirtualClinicAnalysisOperatingNumberConstant(this.value);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  overrideClone(override: OverrideProperty[]): VirtualClinicAnalysisOperatingNumberTerm {
    return new VirtualClinicAnalysisOperatingNumberConstant(this.value);
  }

  getChildResources(): { [resourceName in ShareableType]?: string[] } {
    return {};
  }

  getFullyInpatientCasesFilters(): VirtualClinicAnalysisFullyInpatientCasesFilter[] {
    return [];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getOverrideProperties(tileId: string, dependencyVirtualClinicId: string): OverrideProperty[] {
    return [];
  }

  isValid(): boolean {
    return isCalculationTermComplete<VirtualClinicAnalysisOperatingNumberTerm>(this);
  }

  toJSON(): VirtualClinicAnalysisOperatingNumberConstantTermSpec {
    return {
      type: 'constant',
      value: this.value,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onUpdateVirtualClinicId(virtualClinicId: string): void {
    // nothing to do
  }
}
